import React from 'react';
import { Link } from 'react-router-dom';
import { route } from '../../constants/routes';
import SiteBrand from './SiteBrand';

const PLATFORM_URL = 'https://itjobopportunities.io';

interface Props {
  collapsed?: boolean;
  className?: string;
}

const PoweredByFooter: React.FC<Props> = ({
  collapsed = false,
  className = '',
}) => (
  <footer
    className={`admin-powered-by${collapsed ? ' admin-powered-by--collapsed' : ''}${
      className ? ` ${className}` : ''
    }`}
  >
    <a
      href={PLATFORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="admin-powered-by__link"
      aria-label="Powered by Jobs and Opportunities — Connecting Tech Talent — opens in a new tab"
      title="Jobs & Opportunities"
    >
      {!collapsed ? (
        <span className="admin-powered-by__label">Powered by</span>
      ) : null}
      <SiteBrand
        markSize={collapsed ? 24 : 32}
        layout="stacked"
        showWordmark={!collapsed}
        showTagline={!collapsed}
        markClassName="admin-powered-by__logo"
        variant="default"
      />
    </a>
    {!collapsed ? (
      <nav className="admin-powered-by__legal" aria-label="Legal">
        <Link to={route('/privacy')}>Private Policy</Link>
        <Link to={route('/terms')}>Terms and Conditions</Link>
      </nav>
    ) : null}
  </footer>
);

export default PoweredByFooter;
